import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { QuoteService } from '../../../services/quote/quote.service';
//import { isChromiumDuplicate } from 'src/shared/browser-detection';

@Injectable()
export class QuoteResolver implements Resolve<any> {

  constructor(
    private router: Router,
    private quoteService: QuoteService
  ) { }

  resolve(route: ActivatedRouteSnapshot): Promise<any> {

    const oldQuoteId = parseInt(route.params['quoteId']);

    // if (isChromiumDuplicate('rerate', oldQuoteId))
    //   return;

    return this.quoteService.getQuoteById(oldQuoteId).toPromise().then(
      quote => {
        this.quoteService.setFtlQuote(quote);
      }).catch((error: any) => {
        console.log("TCL: QuoteResolver -> error", error)
        this.router.navigate(['/loadDetails']);
        return '';
      }); 
    }
}
